<template>
    <div class="user-paper-result">
        <span class="title">
            <slot name="title"></slot>
        </span>
        <div class="data-list">
            <div class="data-item">
                <span>
                    <slot name="correct"></slot>
                </span>
                <span style="color: #00b578">答对</span>
            </div>
            <div class="data-item">
                <span>
                    <slot name="wrong"></slot>
                </span>
                <span style="color: #ff3141">答错</span>
            </div>
            <div class="data-item">
                <span>
                    <slot name="time"></slot>
                </span>
                <span style="color: #1677ff">用时</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserPaperResult',
}
</script>

<style lang="less" scoped>
.user-paper-result {
    background: @white;
    padding: 15px;
    border-radius: @large-border-radius;

    .title {
        font-size: @large-font-size;
        font-weight: 500;
    }

    .data-list {
        display: flex;

        .data-item {
            width: calc(100% / 3);
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin-top: 20px;

            span:first-of-type {
                font-size: 30px;
            }

            span:last-of-type {
                font-size: @medium-font-size;
            }
        }
    }
}
</style>
